<script setup lang="ts">
import type { StepsCardRecord } from "~~/server/graphql/datocms/generated";

defineProps<{ step: StepsCardRecord; stepNumber: number }>();
</script>

<template>
  <div class="pt-2xl relative h-full pl-[72px]">
    <div class="absolute left-0 top-0">
      <div class="relative">
        <div class="left-xl top-sm text-dairy absolute z-20 text-[48px] font-bold">
          {{ stepNumber }}
        </div>
        <Vector class="vector--background h-[120px] w-[130px] rotate-0" />
      </div>
    </div>
    <div class="p-lg relative z-20 h-full rounded-sm bg-white">
      <h5 class="mb-2xs font-bold">
        {{ step.title }}
      </h5>
      <div class="markdown-content" v-html="step.text" />
    </div>
  </div>
</template>

<style scoped>
.vector--background {
  --esc-vector-fill-color: #e7f3f3;
  --esc-vector-mix-blend-mode: normal;
  --esc-vector-opacity: 1;
}
</style>
